module.exports = __webpack_public_path__ + "owned_rights.54346423d660f0e9606b49b58776b4ae.svg";